// Secondary

const techblue = {
  100: "#F5FDFF",
  200: "#ECFCFF",
  300: "#D9F8FF",
  400: "#C5F5FF",
  500: "#B2F1FF",
  600: "#9FEEFF",
  700: "#7FBECC",
  800: "#5F8F99",
  900: "#405F66",
  contrastDefaultColor: "#ffffff"
}

export default techblue
